import React from 'react';
import Video from '../home/Video';
import Service from './Service';

const serviceData = [
    {
        name: "Full website creation",
        dash: "I can create any type of website for your business, portfolio, company, e-commerce store, blog etc. I provide unique, clean & awesome graphical design interface.",
        img: "https://i.imgur.com/yB9eGOZ.png"
    }, {
        name: "Online store & shopping",
        dash: "I can create a fully functional online store with any type of payment gateway support and add shopping cart functionality into you’re existing website.",
        img: ""
    }, {
        name: "Fixing problems",
        dash: "Website problem & bugs it’s a common problem for every website. Don’t worry about bugs and problems. I can fix any type of problems & bugs for any website.",
        img: ""
    }, {
        name: "Maintenance & Optimized        ",
        dash: "Slow loading website it’s the biggest problem for every website. I can boost your website’s speed by optimization your website. And if you don’t have time to maintain your website don’t worry I’m here.",
        img: ""
    },
]

const Services = () => {
    return (
        <div className='container mx-auto py-14'>
            <div className="grid grid-cols-9 md:gap-5 gap-2 content-center">
                <div className="lg:col-span-5 col-span-9 grid content-center">
                    <div className="grid grid-cols-4 md:gap-5 gap-2">
                        {serviceData.map((item, i) => (
                            <div key={i} className="md:col-span-2 col-span-4">
                                <Service i={i} item={item} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="lg:col-span-4 col-span-9 grid content-center">
                    {/* <iframe className="w-full aspect-video ..." src="https://www.youtube.com/embed/S4HYwsBRpRs"></iframe> */}
                    <Video />
                </div>
            </div>
        </div>
    );
};

export default Services;